import * as React from "react";
import { DetailActionProps, getNextPage } from "../detail-actions-props";

import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import LoadingIcon from "@material-ui/icons/Timelapse";

import { takedown as takeDownRelease } from "../../../../../sdk/release";
import { useHistory, useLocation } from "react-router";
import { handleReleaseTakenDown } from "../../../../../utils/rudderstack/events";

export const TakeDownRelease: React.FC<DetailActionProps> = (props) => {
  const { data } = props;
  const history = useHistory();
  const location = useLocation<{from?: string}>();

  const [loading, setLoading] = React.useState(false);

  const handleClick = async () => {
    setLoading(true);
    await Promise.all(
      data.map(async ({ release, tracks }) => {
        await takeDownRelease(release.id, release.UPCEAN as string);
        await handleReleaseTakenDown({release, tracks});
      })
    );
    setLoading(false);

    props.onAction(data.map(({ release }) => release.id));

    history.push(getNextPage(location.state?.from), location.state);
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      endIcon={loading ? <LoadingIcon /> : <DeleteIcon />}
      onClick={handleClick}
    >
      Take Down
    </Button>
  );
};
